import { render } from "./BadgeState.vue?vue&type=template&id=688e29bc&scoped=true&ts=true"
import script from "./BadgeState.vue?vue&type=script&lang=ts"
export * from "./BadgeState.vue?vue&type=script&lang=ts"

import "./BadgeState.vue?vue&type=style&index=0&id=688e29bc&lang=scss&scoped=true"
import "./BadgeState.vue?vue&type=style&index=1&id=688e29bc&lang=scss"

import exportComponent from "../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688e29bc"]])

export default __exports__